import { withBasePath } from 'basePath';
import { dispatchAction } from '@ardoq/rxbeach';
import {
  CopyDashboardUrLParams,
  copyDashboardUrlWithStateIdButtonWasClicked,
} from '../../DashboardBuilder/streams/actions';
import {
  copyDashboardUrlToClipboard,
  DashboardEventLocations,
  DashboardTrackingEventsNames,
} from '@ardoq/dashboard';
import { ArdoqId } from '@ardoq/api-types';
import { trackEvent } from '../../../tracking/tracking';
import { isEmpty } from 'lodash';
import { CopyEntityURLButtonProps } from '@ardoq/snowflakes';
import { type I18nLocale, t } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { pathTo } from 'router/declarative/pathTo';

const trackCopyDashboardURL = (
  from:
    | DashboardEventLocations.ARDOQ
    | DashboardEventLocations.DISCOVER
    | DashboardEventLocations.PRESENTATION,
  copyURLType: DashboardEventLocations.ARDOQ | DashboardEventLocations.DISCOVER,
  hasFiltersApplied: boolean = false
) =>
  trackEvent(DashboardTrackingEventsNames.COPIED_DASHBOARD_URL, {
    from,
    copyURLType,
    hasFiltersApplied,
  });

const copyUrlToClipboard = (url: string): Promise<void> =>
  // i18nLocale$.state OK here: imperative one-shot toast notification.
  copyDashboardUrlToClipboard({ url, i18nLocale: i18nLocale$.state });

export const copyDashboardDiscoverURL = (dashboardId: ArdoqId): Promise<void> =>
  copyUrlToClipboard(
    `${window.location.origin}${withBasePath(`/discover/dashboard/${dashboardId}`)}`
  );

export const dashboardReaderUrl = (
  dashboardId: ArdoqId,
  stateId?: ArdoqId
): string =>
  `${window.location.origin}${pathTo(
    '/dashboard/reader/:dashboardId',
    { dashboardId },
    stateId ? { state: stateId } : {}
  )}`;

export const copyDashboardArdoqURL = (
  dashboardId: ArdoqId,
  stateId?: ArdoqId
): Promise<void> =>
  copyUrlToClipboard(dashboardReaderUrl(dashboardId, stateId));

export const getCopyDashboardUrlButtonProps = (
  payload: CopyDashboardUrLParams,
  eventLocation:
    | DashboardEventLocations.ARDOQ
    | DashboardEventLocations.DISCOVER
    | DashboardEventLocations.PRESENTATION,
  hasNewDiscoverCoreNavigation: boolean,
  i18nLocale: I18nLocale
): CopyEntityURLButtonProps => {
  const hasFiltersApplied = !isEmpty(payload.dashboardFilterValues);

  return {
    copyArdoqEntityUrl: () => {
      dispatchAction(copyDashboardUrlWithStateIdButtonWasClicked(payload));
      trackCopyDashboardURL(
        eventLocation,
        DashboardEventLocations.ARDOQ,
        hasFiltersApplied
      );
    },
    copyDiscoverEntityUrl: () => {
      copyDashboardDiscoverURL(payload.id);
      trackCopyDashboardURL(eventLocation, DashboardEventLocations.DISCOVER);
    },
    hasCopyArdoqURLOption: true,
    hasNewDiscoverCoreNavigation,
    labels: {
      copyArdoqEntityUrl: t(
        i18nLocale,
        'dashboard:reader.copyArdoqDashboardUrl',
        'Copy Ardoq dashboard URL'
      ),
      copyDiscoverEntityUrl: t(
        i18nLocale,
        'dashboard:reader.copyDiscoverDashboardUrl',
        'Copy Discover dashboard URL'
      ),
      tooltipText: t(
        i18nLocale,
        'dashboard:reader.copyDashboardUrlTooltip',
        'Copy dashboard URL'
      ),
    },
  };
};
